import { ErrorType } from './error-type';
import { HttpErrorResponse } from '@angular/common/http';

export class ErrorsResponse extends HttpErrorResponse {
    error: CustomError;
}

export class CustomError {
    status: string;
    message: string;
    errors: ErrorType[];
}
